import { render } from "./schoolSafeDetail.vue?vue&type=template&id=34f54cae&scoped=true"
import script from "./schoolSafeDetail.vue?vue&type=script&lang=js"
export * from "./schoolSafeDetail.vue?vue&type=script&lang=js"

import "./schoolSafeDetail.vue?vue&type=style&index=0&id=34f54cae&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f54cae"]])

export default __exports__